import { render } from "./GroupWatchLists.vue?vue&type=template&id=6b772219&ts=true"
import script from "./GroupWatchLists.vue?vue&type=script&lang=ts"
export * from "./GroupWatchLists.vue?vue&type=script&lang=ts"

import "./GroupWatchLists.vue?vue&type=style&index=0&id=6b772219&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__